module.exports = __webpack_public_path__ + "519481b8347fa4a1235b0b8ff7e3c793.svg";